module.exports = __webpack_public_path__ + "static/media/email.68dd6571.png";